
import { defineComponent, ref } from "vue";
import { IPost } from "../../interfaces/IPost";
import { useRouter } from "vue-router";
import { colorLog } from "../../utils/colorLog";
import { useMarkdown } from "../../composables/useMarkdown";
import  HelloRust from '../rust/hello-rust.vue'
import { PostStore } from "../../store/post/post.store";
import { useStore, POST_STORE_SYMBOL } from "../../store";

export default defineComponent({
  components: {
    HelloRust
  },
  props: {
    post: {
      type: Object as () => IPost,
      required: true,
    },
  },
  emits: ['delete-post'],
  setup(props, ctx) {
    const router = useRouter();
    const showBody = ref(true)
    const update = useMarkdown().update
    const html = ref()
    if (props.post.html) {
      html.value = update(props.post.html)
    }
    const postStore: PostStore = useStore<PostStore>(POST_STORE_SYMBOL) as PostStore

    const toPost = () => {
      colorLog("#### to show post ####");
      router.push({
        name: "WaitShowPost",
        params: { id: props.post.id, title: props.post.title, section: props.post.sectionName },
      });
    };
    
    const deletePost = () => {
      colorLog("#### delete post ####");
      postStore.deleteRecord(props.post)
      ctx.emit('delete-post')
    }

    return {
      toPost,
      html,
      showBody,
      deletePost
    };
  },
});
